/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { IconStar } from '@veneer/core';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { RatingProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Rating component
 * @public
 */
const TRating: React.FC<RatingProps> = ({
  id = generateID('clientos-ui-toolkit-rating'),
  state,
  onMouseOver,
  onClick,
  'aria-label': ariaLabel
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key.toLowerCase() === 'enter' || e.key.toLowerCase() === ' ') {
      onClick?.(e);
    }
  };

  return (
    <div
      id={id}
      className="clientos-ui-toolkit-rating"
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseMove={onMouseOver}
      onKeyPress={handleKeyPress}
    >
      <div
        className={`clientos-ui-toolkit-rating__icon clientos-ui-toolkit-rating__icon--${state}`}
        id={`${id}__icon`}
        tabIndex={0}
        role="button"
        aria-label={ariaLabel}
      >
        <IconStar
          size={24}
          filled={
            state === 'hover' ||
            state === 'selected' ||
            state === 'hover--selected'
              ? true
              : false
          }
        />
      </div>
    </div>
  );
};

export const AnalyticsRating = withAnalytics(TRating);
export default memo(TRating);
